import { Component, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { SessionRecoveryService } from 'projects/shared/src/lib/core/services/session-recovery.service';

/**
 * Task 2616 Phase 8 — Shows "Sign in again" for recoverable outcomes.
 *
 * Recoverable outcomes (brand_not_found, identity_not_eligible, application_mismatch):
 *   - The PermissionGuard passes `outcomeCode` via router navigation state.
 *   - If a recovery was already attempted (sessionStorage marker), the button is not shown
 *     to prevent redirect loops.
 */
@Component({
  selector: 'app-access-denied',
  templateUrl: 'access-denied.component.html',
  styleUrl: 'access-denied.component.scss',
  imports: [NgIf],
})
export class AccessDeniedComponent implements OnInit {
  showSignInAgain = false;
  isRecovering = false;
  recoveryFailed = false;

  constructor(
    private _router: Router,
    private _sessionRecovery: SessionRecoveryService,
  ) {}

  ngOnInit(): void {
    // Router navigation state is available during the same navigation event;
    // history.state persists it through a full page reload.
    const state = this._router.getCurrentNavigation()?.extras?.state ?? history.state;
    const outcomeCode: string = state?.outcomeCode ?? '';
    const isRecoverable = SessionRecoveryService.RECOVERABLE_OUTCOMES.has(outcomeCode);
    const alreadyAttempted = this._sessionRecovery.hasRecoveryAttempt();

    this.showSignInAgain = isRecoverable && !alreadyAttempted;
  }

  async signInAgain(): Promise<void> {
    if (this.isRecovering) return;
    this.isRecovering = true;
    try { await this._sessionRecovery.executeSignInAgain(); }
    catch { this.recoveryFailed = true; this.showSignInAgain = false; this.isRecovering = false; }
  }
}
